import SmsTemplates from '../../../store/messages/sms-templates';

angular
    .module('festzelt-os.modules.messages')
    .factory('SmsTemplates', [
        '$injector',
        'SmsTemplate',
        ($injector, SmsTemplate) => new SmsTemplates(SmsTemplate, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/messages/store/sms-templates.js